import { Component } from '@angular/core';

@Component({
  selector: 'app-template-info-blurb',
  templateUrl: './template-info-blurb.component.html',
  styleUrls: ['./template-info-blurb.component.scss'],
  standalone: false
})
export class TemplateInfoBlurbComponent {}
